const EditModeKey: InjectionKey<boolean> = Symbol('edit-mode-inject-key')

export function useEditMode() {
  return inject(EditModeKey, false)
}

export function provideEditMode(editMode: boolean) {
  provide(EditModeKey, editMode)
}
